import React from 'react';
import { PictoProps } from './index';

export const Info = (props: PictoProps) => (
  <svg
    width={props.width || '23'}
    height={props.height || '23'}
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="11.1636"
      cy="11.3053"
      r="10"
      stroke="#004653"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.0137 16.0102L12.8557 16.6956C12.3815 16.8942 12.0024 17.0453 11.7204 17.1492C11.438 17.2533 11.1098 17.3053 10.7358 17.3053C10.1617 17.3053 9.71489 17.1561 9.39646 16.8597C9.07788 16.5623 8.91857 16.1852 8.91857 15.7278C8.91857 15.5507 8.93003 15.3686 8.95418 15.1831C8.97848 14.9976 9.01687 14.7882 9.06966 14.5544L9.6624 12.3296C9.71503 12.1165 9.75992 11.9146 9.79584 11.7237C9.83222 11.5341 9.84986 11.3596 9.84986 11.2023C9.84986 10.9182 9.79429 10.7195 9.68392 10.6078C9.57339 10.4963 9.3627 10.4398 9.04969 10.4398C8.89643 10.4398 8.739 10.4659 8.5783 10.5162C8.41699 10.5666 8.27922 10.6155 8.16357 10.6609L8.32209 9.97492C8.71034 9.80731 9.08155 9.66367 9.43667 9.54449C9.79178 9.42498 10.1273 9.36523 10.4446 9.36523C11.0148 9.36523 11.4548 9.51133 11.7638 9.80372C12.073 10.0963 12.2274 10.4753 12.2274 10.9428C12.2274 11.0395 12.2172 11.2098 12.1956 11.4534C12.1742 11.6975 12.1346 11.9211 12.0767 12.1243L11.4864 14.3405C11.4379 14.5184 11.3946 14.7218 11.3568 14.9508C11.3178 15.1783 11.2992 15.352 11.2992 15.4687C11.2992 15.7631 11.361 15.9638 11.4852 16.0709C11.6102 16.1778 11.8253 16.2308 12.1308 16.2308C12.2745 16.2308 12.4378 16.2037 12.6192 16.1507C12.8002 16.0975 12.9321 16.0509 13.0137 16.0101L13.0137 16.0102ZM13.1636 6.70657C13.1636 7.09268 13.0264 7.42247 12.7507 7.6935C12.4756 7.96552 12.144 8.10177 11.7566 8.10177C11.3676 8.10177 11.0352 7.96568 10.7572 7.6935C10.4793 7.4223 10.3403 7.09266 10.3403 6.70657C10.3403 6.32128 10.4793 5.99083 10.7572 5.71636C11.0349 5.44221 11.3675 5.3053 11.7566 5.3053C12.144 5.3053 12.4756 5.44254 12.7507 5.71636C13.0264 5.99084 13.1636 6.32115 13.1636 6.70657Z"
      fill="#004653"
    />
  </svg>
);
